import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ExportDialog({ open, onClose, onConfirm, title = "تصدير التقرير" }) {
  const [names, setNames] = useState([]);
  const [selected, setSelected] = useState(null); // null = all employees

  useEffect(() => {
    if (!open) return;
    setSelected(null);
    api.get("/attendance/employees")
      .then((r) => setNames(r.data.map((e) => e.employee_name)))
      .catch(() => setNames([]));
  }, [open]);

  const allSelected = selected === null;
  const toggleAll = () => setSelected(allSelected ? [] : null);
  const toggle = (n) => setSelected((prev) => {
    const cur = prev === null ? [...names] : [...prev];
    return cur.includes(n) ? cur.filter((x) => x !== n) : [...cur, n];
  });

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" dir="rtl" data-testid="export-dialog">
        <DialogHeader>
          <DialogTitle>{title} — اختيار الموظفين</DialogTitle>
        </DialogHeader>
        <label className="flex items-center gap-2 border rounded-xl px-3 py-2.5 cursor-pointer hover:bg-slate-50">
          <Checkbox checked={allSelected} onCheckedChange={toggleAll} data-testid="export-select-all" />
          <span className="text-sm font-semibold">جميع الموظفين (تحديد الكل)</span>
        </label>
        <div className="max-h-64 overflow-y-auto space-y-1 border rounded-xl p-2" data-testid="export-employee-list">
          {names.length === 0 && <p className="text-xs text-slate-400 text-center py-4">لا يوجد موظفون</p>}
          {names.map((n, i) => (
            <label key={n} className="flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer hover:bg-slate-50">
              <Checkbox checked={allSelected || selected.includes(n)} onCheckedChange={() => toggle(n)}
                data-testid={`export-emp-${i}`} />
              <span className="text-sm">{n}</span>
            </label>
          ))}
        </div>
        <Button onClick={() => onConfirm(allSelected ? null : selected)}
          disabled={!allSelected && selected.length === 0}
          data-testid="export-confirm-btn"
          className="w-full bg-emerald-900 hover:bg-emerald-950 text-white">
          {allSelected ? "تصدير لجميع الموظفين" : `تصدير للمحددين (${selected?.length || 0})`}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
